import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  CreateNewSalesRepMapSuccessComponent, type CreateNewSalesRepMapSuccessComponentProps,
} from './createNewSalesRepMapSuccess.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    CreateNewSalesRepMapSuccess: CreateNewSalesRepMapSuccessComponentProps;
  }
}
modalRenderer.register('CreateNewSalesRepMapSuccess', CreateNewSalesRepMapSuccessComponent);
